import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { fmtDateTime } from "../lib/date";
import { CaretDown, Gear, Robot, User, ArrowRight } from "@phosphor-icons/react";

const LINK_PATH = {
  asset: (id) => `/assets/${id}`,
  person: () => `/people`,
  havs_person: (id) => `/havs?person=${id}`,
  maintenance_job: (id) => `/maintenance/jobs/${id}`,
  rams: () => `/rams`,
};

export default function AuditCard({ item, isAdmin }) {
  const nav = useNavigate();
  const [tech, setTech] = useState(false);
  const when = item.when ? new Date(item.when) : null;
  const openLink = () => {
    if (item.link && LINK_PATH[item.link.type]) nav(LINK_PATH[item.link.type](item.link.id));
  };

  return (
    <div data-testid={`audit-row-${item.id}`}
      className={`bg-white rounded-lg border-l-4 ${item.is_system ? "border-slate-400" : "border-blue-500"} border border-slate-200 p-3 sm:p-4`}>
      <div className="flex items-start gap-2 flex-wrap">
        <span className="inline-flex items-center gap-1.5 font-body font-semibold text-slate-800 text-sm">
          {item.is_system ? <Robot size={16} weight="bold" className="text-slate-500" /> : <User size={16} weight="bold" className="text-blue-500" />}
          {item.who}
        </span>
        <span className="font-body text-sm text-slate-500">{item.action_label}</span>
        <span className="ml-auto font-mono text-[11px] text-slate-400 whitespace-nowrap">
          {when ? fmtDateTime(when) : ""}
        </span>
      </div>

      {item.subject && (
        item.link
          ? <button data-testid={`audit-subject-${item.id}`} onClick={openLink}
              className="mt-1 inline-flex items-center gap-1 font-body font-semibold text-slate-900 text-sm hover:text-blue-600 text-left break-words">
              {item.subject} <ArrowRight size={13} weight="bold" className="opacity-60" />
            </button>
          : <div className="mt-1 font-body font-semibold text-slate-900 text-sm break-words">{item.subject}</div>
      )}

      {item.lines?.length > 0 && (
        <div className="mt-1 flex flex-col gap-0.5">
          {item.lines.map((l, i) => <div key={i} className="font-body text-sm text-slate-600 break-words">{l}</div>)}
        </div>
      )}

      {item.changes?.length > 0 && (
        <div className="mt-2 flex flex-col gap-1">
          {item.changes.map((c, i) => (
            <div key={i} className="text-xs font-body bg-slate-50 rounded px-2 py-1 border border-slate-100 break-words">
              <span className="font-semibold text-slate-700">{c.field}</span>{" "}
              <span className="text-slate-500 line-through">{c.old}</span>{" "}
              <ArrowRight size={11} weight="bold" className="inline text-slate-400" />{" "}
              <span className="text-slate-900 font-medium">{c.new}</span>
            </div>
          ))}
        </div>
      )}

      {item.reason && <div className="mt-1 font-body text-xs text-slate-500">Reason: {item.reason}</div>}

      {isAdmin && item.technical && (
        <div className="mt-2 border-t border-slate-100 pt-1">
          <button data-testid={`audit-tech-toggle-${item.id}`} onClick={() => setTech(!tech)}
            className="inline-flex items-center gap-1 text-[11px] font-semibold text-slate-400 hover:text-slate-600">
            <Gear size={12} weight="bold" /> Technical Details <CaretDown size={10} weight="bold" className={tech ? "rotate-180 transition-transform" : "transition-transform"} />
          </button>
          {tech && (
            <pre className="mt-1 text-[10px] font-mono bg-slate-900 text-slate-200 rounded p-2 overflow-x-auto whitespace-pre-wrap break-all">
{JSON.stringify(item.technical, null, 2)}
            </pre>
          )}
        </div>
      )}
    </div>
  );
}
